import { serverTimestamp } from 'firebase/firestore'
import {
  typedCollection,
  typedDoc,
  getCollection,
  updateDocument,
  orderBy,
  arrayUnion,
} from '@/lib/firebase/firestore'
import type { NotificationDocument } from '@/types'

const notificationsCol = () => typedCollection<NotificationDocument>('notifications')

export const notificationsService = {
  async getAllNotifications(): Promise<Array<NotificationDocument & { id: string }>> {
    return getCollection(notificationsCol(), orderBy('createdAt', 'desc'))
  },

  async markRead(id: string, uid: string): Promise<void> {
    const ref = typedDoc<NotificationDocument>('notifications', id)
    await updateDocument(ref, {
      readBy: arrayUnion(uid) as unknown as string[],
      updatedAt: serverTimestamp(),
    })
  },

  async resolve(id: string, resolvedByUid: string): Promise<void> {
    const ref = typedDoc<NotificationDocument>('notifications', id)
    await updateDocument(ref, {
      resolved: true,
      resolvedBy: resolvedByUid,
      resolvedAt: new Date(),
      updatedAt: serverTimestamp(),
    })
  },
}
